import React, { useContext, useState } from "react";
import AppContext, { AuthWizardContext } from "../../../context/Context";
import WizardModal from "../../common/wizard/WizardModal";
import { Button, Card, Nav } from "react-bootstrap";
import RegistrationFormNew from "../RegistrationFormNew";
import { NavItem, NavItemPill } from "../../user/PushlishApplication/Publish";
import classNames from "classnames";
import { Col, Row } from "reactstrap";
import RegisterPayment from "./RegisterPayment";
import IconButton from "../../common/IconButton";
import { useForm } from "react-hook-form";
import { GetParamterFromLink } from "../../../helpers/utils";

const Payment = ({ variant, validation, progressBar }) => {
  const { isRTL } = useContext(AppContext);
  const { user, setUser, step, setStep } = useContext(AuthWizardContext);
  const [modal, setModal] = useState(false);
  const [registerFormValues, setRegisterFormValues] = useState({});
  const [paymentFormValues, setPaymentFormValues] = useState({});

  const isTokenExist = GetParamterFromLink("token") ? true : false;
  const inviteQKey = GetParamterFromLink("q") ? true : false;
  const inviteTKey = GetParamterFromLink("t") ? true : false;

  const navItems = [
    {
      icon: "lock",
      label: "Register",
    },
    {
      icon: "credit-card",
      label: "Payment methods",
    },
  ].filter((item) => {
    if (isTokenExist) {
      return item.label !== "Payment methods";
    }
    return true; // If no token, show all items
  });

  return (
    <>
      {isTokenExist || (inviteQKey && inviteTKey) ? (
        <>
          <RegistrationFormNew
            registerFormValues={registerFormValues}
            setRegisterFormValues={setRegisterFormValues}
            setStep={setStep}
            step={step}
          />
        </>
      ) : (
        <>
          <WizardModal modal={modal} setModal={setModal} />
          {/* <Card className="theme-wizard"> */}

          {/* <Nav className={"theme-wizard"} variant={variant}>
            {variant === "pills"
              ? navItems.map((item, index) => (
                  <NavItemPill
                    key={item.label}
                    index={index + 1}
                    step={step}
                    handleNavs={""}
                    icon={item.icon}
                    label={item.label}
                  />
                ))
              : navItems.map((item, index) => (
                  <NavItem
                    key={item.label}
                    index={index + 1}
                    step={step}
                    handleNavs={""}
                    icon={item.icon}
                    label={item.label}
                  />
                ))}
          </Nav> */}

          {step == 1 ? (
            <>
              <RegistrationFormNew
                registerFormValues={registerFormValues}
                setRegisterFormValues={setRegisterFormValues}
                setStep={setStep}
                step={step}
              />
            </>
          ) : (
            <></>
          )}
          {step == 2 ? (
            <>
              <RegisterPayment
                registerFormValues={registerFormValues}
                setRegisterFormValues={setRegisterFormValues}
                setStep={setStep}
                step={step}
                setPaymentFormValues={setPaymentFormValues}
                paymentFormValues={paymentFormValues}
              />
            </>
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
};

export default Payment;
